export default __webpack_public_path__ + "static/media/AE10.e9ae67b0.jpg";